.container {
  font-family: var(--fonts-body);
  font-weight: var(--font-weights-regular);
  font-size: var(--font-sizes-80);
  line-height: var(--line-heights-100);
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: currentColor;
}

.container:where([data-placement='start']) {
  margin: 0 calc(-1 * var(--spaces-4)) 0 var(--spaces-8);
}

.container:where([data-placement='end']) {
  margin: 0 var(--spaces-8) 0 0;
}
